import {
    BarChart, Bar, XAxis, YAxis, Tooltip,
    ResponsiveContainer, CartesianGrid,
} from 'recharts';

export default function DistributionChart({ levels }) {
    if (!levels || levels.length === 0) return null;

    const data = levels.map((lvl) => ({
        name: `سطح ${lvl.level}`,
        percent: Number(lvl.percent),
    }));

    return (
        <div className="distribution-chart">
            <h3>توزیع پورسانت بین سطوح</h3>
            <ResponsiveContainer width="100%" height={280}>
                <BarChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                    <XAxis dataKey="name" />
                    <YAxis unit="%" />
                    <Tooltip
                        formatter={(value) => [`${value.toFixed(4)}٪`, 'درصد']}
                        labelStyle={{ direction: 'rtl' }}
                    />
                    <Bar dataKey="percent" fill="#3b82f6" radius={[6, 6, 0, 0]} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}